import { render, staticRenderFns } from "./FailedSalaryReport.vue?vue&type=template&id=7ab6805e&"
import script from "./FailedSalaryReport.vue?vue&type=script&setup=true&lang=js&"
export * from "./FailedSalaryReport.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports